export const KNOWHERE_COORDINATE = {
  latitude: -1,
  longitude: -1,
};
